import React from 'react';
import { Helmet } from 'react-helmet';

export const DEFAULT_SEO_DESCRIPTION = 'Justin Hadad is a postdoctoral scholar in economics at Stanford University researching market design and economic theory.';

const SEO = ({
  title,
  description,
  image = '/logo.png',
  pathname,
  keywords = [],
  isPublication = false
}) => {
  const siteUrl = 'https://justinhadad.com';
  const siteTitle = 'Justin Hadad';
  const siteDescription = DEFAULT_SEO_DESCRIPTION;
  const canonicalUrl = new URL(pathname || '/', siteUrl).toString();
  const imageUrl = new URL(image, siteUrl).toString();
  
  const seo = {
    title: title ? `${title} | ${siteTitle}` : siteTitle,
    description: description || siteDescription,
    image: imageUrl,
    url: canonicalUrl
  };

  // Enhanced schema for academic content
  const schemaOrgWebPage = {
    '@context': 'http://schema.org',
    '@type': isPublication ? 'ScholarlyArticle' : 'WebPage',
    url: seo.url,
    name: seo.title,
    description: seo.description,
    author: {
      '@type': 'Person',
      name: 'Justin Hadad',
      affiliation: {
        '@type': 'Organization',
        name: 'Stanford University'
      }
    }
  };

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="keywords" content={keywords.join(', ')} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={seo.url} />
      
      {/* Open Graph Tags (used by LinkedIn, Slack, Facebook, etc) */}
      <meta property="og:type" content={isPublication ? 'article' : 'website'} />
      <meta property="og:site_name" content={siteTitle} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:image:alt" content={seo.title} />
      <meta property="og:url" content={seo.url} />

      {/* X/Twitter cards */}
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:image:alt" content={seo.title} />
      
      {/* Schema.org JSON-LD */}
      <script type="application/ld+json">
        {JSON.stringify(schemaOrgWebPage)}
      </script>
    </Helmet>
  );
};

export default SEO;
